import avatarPlaceholder from "../assets/directory/avatar-placeholder.svg";

/** Shown for every directory listing (remote profile URLs are no longer used). */
export const DIRECTORY_AVATAR_PLACEHOLDER = avatarPlaceholder;

/** Always returns the local avatar placeholder. `item` kept for call-site compatibility. */
export function directoryProfileImageSrc(_item) {
  return avatarPlaceholder;
}
